import React from 'react'
import PropTypes from 'prop-types'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import { dateToBR } from 'utils/date'
import { Container } from './styles'

export default function StockTracking(props) {
  const {
    stockTracking,
  } = props

  return (
    <DescList>
      <Container>
        <DescItemList label="Data">
          {dateToBR(stockTracking.attributes.date)}
        </DescItemList>
        <DescItemList label="Descrição">
          {stockTracking.attributes.description}
        </DescItemList>
        <DescItemList label="Quantidade">
          {stockTracking.attributes.quantity}
        </DescItemList>
      </Container>
    </DescList>
  )
}

StockTracking.propTypes = {
  stockTracking: PropTypes.objectOf(PropTypes.any),
}

StockTracking.defaultProps = {
  stockTracking: {},
}
